module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/ankle-669c5c5b9f5aa2c58c9a3882c1c2837f.svg";